const addSpeakerToUtterance = (speakers) => (utterance) => (Object.assign(Object.assign({}, utterance), { sttSpeaker: speakers[utterance.sttSpeakerId] }));
function speakersToLookup(speakers) {
    return speakers.reduce((acc, speaker) => (Object.assign({ [speaker.id]: speaker }, acc)), {});
}
export function addSpeakerToUtterances(sttUtterances, sttSpeakers) {
    return sttUtterances.map(addSpeakerToUtterance(speakersToLookup(sttSpeakers)));
}
